/**
 * ゾーンマップの色系統 (可変施肥・高低差共通)。
 * hue = HSI系 (低=緑 → 黄 → 高=赤、既定) / ylgn = 黄→緑 / gnrd = 緑→赤
 * feed-api の ZONE_PALETTES と対応する。
 */
export const DEFAULT_PALETTE = 'hue'

const STOPS = {
  ylgn: [[0xf7, 0xfc, 0xb9], [0xad, 0xdd, 0x8e], [0x31, 0xa3, 0x54]],
  gnrd: [[0x1a, 0x98, 0x50], [0xa6, 0xd9, 0x6a], [0xfe, 0xe0, 0x8b], [0xf4, 0x6d, 0x43], [0xd7, 0x30, 0x27]],
}

function hslToRgb(h, s, l) {
  const c = (1 - Math.abs(2 * l - 1)) * s
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
  const m = l - c / 2
  let rgb
  if (h < 60) rgb = [c, x, 0]
  else if (h < 120) rgb = [x, c, 0]
  else if (h < 180) rgb = [0, c, x]
  else if (h < 240) rgb = [0, x, c]
  else if (h < 300) rgb = [x, 0, c]
  else rgb = [c, 0, x]
  return rgb.map(v => Math.round((v + m) * 255))
}

/** t (0..1, 低→高) をパレットの RGB [r,g,b] にする */
export function paletteRgb(palette, t) {
  const tt = Math.max(0, Math.min(1, t))
  const stops = STOPS[palette]
  if (!stops) {
    // HSI系: 色相 120°(緑) → 60°(黄) → 0°(赤)
    return hslToRgb(120 * (1 - tt), 0.75, 0.5)
  }
  const x = tt * (stops.length - 1)
  const i = Math.min(Math.floor(x), stops.length - 2)
  const f = x - i
  return stops[i].map((v, k) => Math.round(v + (stops[i + 1][k] - v) * f))
}

/** t (0..1) を '#rrggbb' にする */
export function paletteColor(palette, t) {
  return (
    '#' +
    paletteRgb(palette, t)
      .map(v => v.toString(16).padStart(2, '0'))
      .join('')
  )
}

export function normPalette(p) {
  return p === 'hue' || p === 'ylgn' || p === 'gnrd' ? p : DEFAULT_PALETTE
}
